import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortActiveVesselsComponent } from './port-active-vessels.component';

import { MaterialModule } from 'src/app/shared/material/material.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { ExpansionPanelModule } from "src/app/shared/components/expansion-panel/expansion-panel.module";
import { MatSortModule } from '@angular/material/sort';

@NgModule({
  declarations: [PortActiveVesselsComponent],
  imports: [
    CommonModule,
    CustomDatePickerModule,
    PcMultiSelectFilterModule,
    MaterialModule,
    CustomInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    ExpansionPanelModule,
    MatSortModule,
],
  exports: [PortActiveVesselsComponent],
})
export class PortActiveVesselsModule {}
